module.exports = __webpack_public_path__ + "img/EH.59920767.png";